import { buildCollection, buildProperty } from "@firecms/core";

import { cleanUpReplacedUploads } from "./uploadCleanup";

export type Testimonial = {
  name: string;
  animal: string;
  quote: string;
  image?: string;
  excerpt?: string;
  order?: number;
  createdAt?: Date;
};

// Mirrors the `testimonials` schema and its validator in firestore.rules.
// `image` stores a download URL (storeUrl: true) for direct use in <img src>.
export const testimonialsCollection = buildCollection<Testimonial>({
  name: "Testimonials",
  singularName: "Testimonial",
  id: "testimonials",
  path: "testimonials",
  icon: "FormatQuote",
  group: "Content",
  description: "Client testimonials shown on the Community page and the site carousel.",
  initialSort: ["order", "asc"],
  // Replacing or deleting a testimonial leaves its photo in the bucket
  // otherwise. External links in older entries are left alone.
  callbacks: cleanUpReplacedUploads,
  properties: {
    name: {
      name: "Person's name",
      dataType: "string",
      validation: { required: true, max: 100 },
    },
    animal: {
      name: "Animal's name",
      dataType: "string",
      validation: { required: true, max: 100 },
    },
    quote: {
      name: "Quote",
      dataType: "string",
      multiline: true,
      validation: { required: true, max: 5000 },
    },
    image: buildProperty({
      name: "Photo",
      dataType: "string",
      storage: {
        storagePath: "testimonials",
        acceptedFiles: ["image/*"],
        maxSize: 5 * 1024 * 1024,
        storeUrl: true,
      },
      description:
        "Photo of the animal. Existing entries may show an external link instead of an upload.",
    }),
    excerpt: {
      name: "Short excerpt",
      dataType: "string",
      multiline: true,
      validation: { max: 2000 },
      description:
        "Optional shorter pull-quote, used if this person is shown as a story card on the Community & Stories page. Leave blank to use the full quote.",
    },
    order: {
      name: "Sort order",
      dataType: "number",
      description: "Lower numbers appear first.",
    },
    createdAt: {
      name: "Created",
      dataType: "date",
      autoValue: "on_create",
      disabled: { hidden: true },
    },
  },
});
